import {
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
} from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'admin.accounts.new.emailInvitation',
    defaultMessage: 'Send invitation emails?',
  },
  yes: {
    id: 'GLOBAL.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'GLOBAL.no',
    defaultMessage: 'No',
  },
});

interface EmailInvitationProps {
  /** Value of the component */
  sendInvite: boolean;
  /** Callback that fires when the selected email invite option changes */
  onChange: (sendInvite: boolean) => void;
}

/** For selecting an email invitation property */
function EmailInvitation({ sendInvite, onChange }: EmailInvitationProps) {
  const { formatMessage } = useIntl();

  return (
    <Card sx={{ width: 'fit-content' }}>
      <CardContent>
        <FormControl>
          <Stack direction="row" gap={1}>
            <FormLabel id="email-invitation-input-label">
              {formatMessage(messages.title)}
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="email-invitation-input-label"
              onChange={(_event, value) =>
                onChange(value.toString() === 'true')
              }
              value={sendInvite}
            >
              <FormControlLabel
                value={false}
                control={<Radio />}
                label={formatMessage(messages.no)}
              />
              <FormControlLabel
                value={true}
                control={<Radio />}
                label={formatMessage(messages.yes)}
              />
            </RadioGroup>
          </Stack>
        </FormControl>
      </CardContent>
    </Card>
  );
}

export { EmailInvitation };
